"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedelegateTx = exports.Redelegations = exports.KVUpdate = exports.ValidatorUnbonding = exports.UserUnbonding = exports.Unbonding = exports.LSMDeposit = exports.Deposit = exports.Validator = exports.ICAAccount = exports.HostChainLSParams = exports.RewardParams = exports.HostChainFlags = exports.HostChain = exports.redelegateTx_RedelegateTxStateToJSON = exports.redelegateTx_RedelegateTxStateFromJSON = exports.RedelegateTx_RedelegateTxState = exports.unbonding_UnbondingStateToJSON = exports.unbonding_UnbondingStateFromJSON = exports.Unbonding_UnbondingState = exports.lSMDeposit_LSMDepositStateToJSON = exports.lSMDeposit_LSMDepositStateFromJSON = exports.LSMDeposit_LSMDepositState = exports.deposit_DepositStateToJSON = exports.deposit_DepositStateFromJSON = exports.Deposit_DepositState = exports.iCAAccount_ChannelStateToJSON = exports.iCAAccount_ChannelStateFromJSON = exports.ICAAccount_ChannelState = exports.protobufPackage = void 0;
/* eslint-disable */
const coin_1 = require("../../../cosmos/base/v1beta1/coin");
const timestamp_1 = require("../../../google/protobuf/timestamp");
const staking_1 = require("../../../cosmos/staking/v1beta1/staking");
const binary_1 = require("../../../binary");
const helpers_1 = require("../../../helpers");
exports.protobufPackage = "pstake.liquidstakeibc.v1beta1";
var ICAAccount_ChannelState;
(function (ICAAccount_ChannelState) {
    /** ICA_CHANNEL_CREATING - ICA channel is being created */
    ICAAccount_ChannelState[ICAAccount_ChannelState["ICA_CHANNEL_CREATING"] = 0] = "ICA_CHANNEL_CREATING";
    /** ICA_CHANNEL_CREATED - ICA is established and the account can be used */
    ICAAccount_ChannelState[ICAAccount_ChannelState["ICA_CHANNEL_CREATED"] = 1] = "ICA_CHANNEL_CREATED";
    ICAAccount_ChannelState[ICAAccount_ChannelState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(ICAAccount_ChannelState = exports.ICAAccount_ChannelState || (exports.ICAAccount_ChannelState = {}));
function iCAAccount_ChannelStateFromJSON(object) {
    switch (object) {
        case 0:
        case "ICA_CHANNEL_CREATING":
            return ICAAccount_ChannelState.ICA_CHANNEL_CREATING;
        case 1:
        case "ICA_CHANNEL_CREATED":
            return ICAAccount_ChannelState.ICA_CHANNEL_CREATED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return ICAAccount_ChannelState.UNRECOGNIZED;
    }
}
exports.iCAAccount_ChannelStateFromJSON = iCAAccount_ChannelStateFromJSON;
function iCAAccount_ChannelStateToJSON(object) {
    switch (object) {
        case ICAAccount_ChannelState.ICA_CHANNEL_CREATING:
            return "ICA_CHANNEL_CREATING";
        case ICAAccount_ChannelState.ICA_CHANNEL_CREATED:
            return "ICA_CHANNEL_CREATED";
        case ICAAccount_ChannelState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.iCAAccount_ChannelStateToJSON = iCAAccount_ChannelStateToJSON;
var Deposit_DepositState;
(function (Deposit_DepositState) {
    /** DEPOSIT_PENDING - no action has been initiated on the deposit */
    Deposit_DepositState[Deposit_DepositState["DEPOSIT_PENDING"] = 0] = "DEPOSIT_PENDING";
    /** DEPOSIT_SENT - deposit sent to the host chain delegator address */
    Deposit_DepositState[Deposit_DepositState["DEPOSIT_SENT"] = 1] = "DEPOSIT_SENT";
    /** DEPOSIT_RECEIVED - deposit received by the host chain delegator address */
    Deposit_DepositState[Deposit_DepositState["DEPOSIT_RECEIVED"] = 2] = "DEPOSIT_RECEIVED";
    /** DEPOSIT_DELEGATING - delegation submitted for the deposit on the host chain */
    Deposit_DepositState[Deposit_DepositState["DEPOSIT_DELEGATING"] = 3] = "DEPOSIT_DELEGATING";
    Deposit_DepositState[Deposit_DepositState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Deposit_DepositState = exports.Deposit_DepositState || (exports.Deposit_DepositState = {}));
function deposit_DepositStateFromJSON(object) {
    switch (object) {
        case 0:
        case "DEPOSIT_PENDING":
            return Deposit_DepositState.DEPOSIT_PENDING;
        case 1:
        case "DEPOSIT_SENT":
            return Deposit_DepositState.DEPOSIT_SENT;
        case 2:
        case "DEPOSIT_RECEIVED":
            return Deposit_DepositState.DEPOSIT_RECEIVED;
        case 3:
        case "DEPOSIT_DELEGATING":
            return Deposit_DepositState.DEPOSIT_DELEGATING;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Deposit_DepositState.UNRECOGNIZED;
    }
}
exports.deposit_DepositStateFromJSON = deposit_DepositStateFromJSON;
function deposit_DepositStateToJSON(object) {
    switch (object) {
        case Deposit_DepositState.DEPOSIT_PENDING:
            return "DEPOSIT_PENDING";
        case Deposit_DepositState.DEPOSIT_SENT:
            return "DEPOSIT_SENT";
        case Deposit_DepositState.DEPOSIT_RECEIVED:
            return "DEPOSIT_RECEIVED";
        case Deposit_DepositState.DEPOSIT_DELEGATING:
            return "DEPOSIT_DELEGATING";
        case Deposit_DepositState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.deposit_DepositStateToJSON = deposit_DepositStateToJSON;
var LSMDeposit_LSMDepositState;
(function (LSMDeposit_LSMDepositState) {
    /** DEPOSIT_PENDING - no action has been initiated on the deposit */
    LSMDeposit_LSMDepositState[LSMDeposit_LSMDepositState["DEPOSIT_PENDING"] = 0] = "DEPOSIT_PENDING";
    /** DEPOSIT_SENT - deposit sent to the host chain delegator address */
    LSMDeposit_LSMDepositState[LSMDeposit_LSMDepositState["DEPOSIT_SENT"] = 1] = "DEPOSIT_SENT";
    /** DEPOSIT_RECEIVED - deposit received by the host chain delegator address */
    LSMDeposit_LSMDepositState[LSMDeposit_LSMDepositState["DEPOSIT_RECEIVED"] = 2] = "DEPOSIT_RECEIVED";
    /** DEPOSIT_UNTOKENIZING - deposit started the untokenization process */
    LSMDeposit_LSMDepositState[LSMDeposit_LSMDepositState["DEPOSIT_UNTOKENIZING"] = 3] = "DEPOSIT_UNTOKENIZING";
    LSMDeposit_LSMDepositState[LSMDeposit_LSMDepositState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(LSMDeposit_LSMDepositState = exports.LSMDeposit_LSMDepositState || (exports.LSMDeposit_LSMDepositState = {}));
function lSMDeposit_LSMDepositStateFromJSON(object) {
    switch (object) {
        case 0:
        case "DEPOSIT_PENDING":
            return LSMDeposit_LSMDepositState.DEPOSIT_PENDING;
        case 1:
        case "DEPOSIT_SENT":
            return LSMDeposit_LSMDepositState.DEPOSIT_SENT;
        case 2:
        case "DEPOSIT_RECEIVED":
            return LSMDeposit_LSMDepositState.DEPOSIT_RECEIVED;
        case 3:
        case "DEPOSIT_UNTOKENIZING":
            return LSMDeposit_LSMDepositState.DEPOSIT_UNTOKENIZING;
        case -1:
        case "UNRECOGNIZED":
        default:
            return LSMDeposit_LSMDepositState.UNRECOGNIZED;
    }
}
exports.lSMDeposit_LSMDepositStateFromJSON = lSMDeposit_LSMDepositStateFromJSON;
function lSMDeposit_LSMDepositStateToJSON(object) {
    switch (object) {
        case LSMDeposit_LSMDepositState.DEPOSIT_PENDING:
            return "DEPOSIT_PENDING";
        case LSMDeposit_LSMDepositState.DEPOSIT_SENT:
            return "DEPOSIT_SENT";
        case LSMDeposit_LSMDepositState.DEPOSIT_RECEIVED:
            return "DEPOSIT_RECEIVED";
        case LSMDeposit_LSMDepositState.DEPOSIT_UNTOKENIZING:
            return "DEPOSIT_UNTOKENIZING";
        case LSMDeposit_LSMDepositState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.lSMDeposit_LSMDepositStateToJSON = lSMDeposit_LSMDepositStateToJSON;
var Unbonding_UnbondingState;
(function (Unbonding_UnbondingState) {
    /** UNBONDING_PENDING - no action has been initiated on the unbonding */
    Unbonding_UnbondingState[Unbonding_UnbondingState["UNBONDING_PENDING"] = 0] = "UNBONDING_PENDING";
    /** UNBONDING_INITIATED - unbonding action has been sent to the host chain */
    Unbonding_UnbondingState[Unbonding_UnbondingState["UNBONDING_INITIATED"] = 1] = "UNBONDING_INITIATED";
    /** UNBONDING_MATURING - unbonding is waiting for the maturing period of the host chain */
    Unbonding_UnbondingState[Unbonding_UnbondingState["UNBONDING_MATURING"] = 2] = "UNBONDING_MATURING";
    /** UNBONDING_MATURED - unbonding has matured and is ready to transfer from the host chain */
    Unbonding_UnbondingState[Unbonding_UnbondingState["UNBONDING_MATURED"] = 3] = "UNBONDING_MATURED";
    /** UNBONDING_CLAIMABLE - unbonding is on the persistence chain and can be claimed */
    Unbonding_UnbondingState[Unbonding_UnbondingState["UNBONDING_CLAIMABLE"] = 4] = "UNBONDING_CLAIMABLE";
    /** UNBONDING_FAILED - unbonding has failed */
    Unbonding_UnbondingState[Unbonding_UnbondingState["UNBONDING_FAILED"] = 5] = "UNBONDING_FAILED";
    Unbonding_UnbondingState[Unbonding_UnbondingState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(Unbonding_UnbondingState = exports.Unbonding_UnbondingState || (exports.Unbonding_UnbondingState = {}));
function unbonding_UnbondingStateFromJSON(object) {
    switch (object) {
        case 0:
        case "UNBONDING_PENDING":
            return Unbonding_UnbondingState.UNBONDING_PENDING;
        case 1:
        case "UNBONDING_INITIATED":
            return Unbonding_UnbondingState.UNBONDING_INITIATED;
        case 2:
        case "UNBONDING_MATURING":
            return Unbonding_UnbondingState.UNBONDING_MATURING;
        case 3:
        case "UNBONDING_MATURED":
            return Unbonding_UnbondingState.UNBONDING_MATURED;
        case 4:
        case "UNBONDING_CLAIMABLE":
            return Unbonding_UnbondingState.UNBONDING_CLAIMABLE;
        case 5:
        case "UNBONDING_FAILED":
            return Unbonding_UnbondingState.UNBONDING_FAILED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return Unbonding_UnbondingState.UNRECOGNIZED;
    }
}
exports.unbonding_UnbondingStateFromJSON = unbonding_UnbondingStateFromJSON;
function unbonding_UnbondingStateToJSON(object) {
    switch (object) {
        case Unbonding_UnbondingState.UNBONDING_PENDING:
            return "UNBONDING_PENDING";
        case Unbonding_UnbondingState.UNBONDING_INITIATED:
            return "UNBONDING_INITIATED";
        case Unbonding_UnbondingState.UNBONDING_MATURING:
            return "UNBONDING_MATURING";
        case Unbonding_UnbondingState.UNBONDING_MATURED:
            return "UNBONDING_MATURED";
        case Unbonding_UnbondingState.UNBONDING_CLAIMABLE:
            return "UNBONDING_CLAIMABLE";
        case Unbonding_UnbondingState.UNBONDING_FAILED:
            return "UNBONDING_FAILED";
        case Unbonding_UnbondingState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.unbonding_UnbondingStateToJSON = unbonding_UnbondingStateToJSON;
var RedelegateTx_RedelegateTxState;
(function (RedelegateTx_RedelegateTxState) {
    /** REDELEGATE_SENT - redelegate txn sent */
    RedelegateTx_RedelegateTxState[RedelegateTx_RedelegateTxState["REDELEGATE_SENT"] = 0] = "REDELEGATE_SENT";
    /** REDELEGATE_ACKED - redelegate txn acked */
    RedelegateTx_RedelegateTxState[RedelegateTx_RedelegateTxState["REDELEGATE_ACKED"] = 1] = "REDELEGATE_ACKED";
    RedelegateTx_RedelegateTxState[RedelegateTx_RedelegateTxState["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(RedelegateTx_RedelegateTxState = exports.RedelegateTx_RedelegateTxState || (exports.RedelegateTx_RedelegateTxState = {}));
function redelegateTx_RedelegateTxStateFromJSON(object) {
    switch (object) {
        case 0:
        case "REDELEGATE_SENT":
            return RedelegateTx_RedelegateTxState.REDELEGATE_SENT;
        case 1:
        case "REDELEGATE_ACKED":
            return RedelegateTx_RedelegateTxState.REDELEGATE_ACKED;
        case -1:
        case "UNRECOGNIZED":
        default:
            return RedelegateTx_RedelegateTxState.UNRECOGNIZED;
    }
}
exports.redelegateTx_RedelegateTxStateFromJSON = redelegateTx_RedelegateTxStateFromJSON;
function redelegateTx_RedelegateTxStateToJSON(object) {
    switch (object) {
        case RedelegateTx_RedelegateTxState.REDELEGATE_SENT:
            return "REDELEGATE_SENT";
        case RedelegateTx_RedelegateTxState.REDELEGATE_ACKED:
            return "REDELEGATE_ACKED";
        case RedelegateTx_RedelegateTxState.UNRECOGNIZED:
        default:
            return "UNRECOGNIZED";
    }
}
exports.redelegateTx_RedelegateTxStateToJSON = redelegateTx_RedelegateTxStateToJSON;
function createBaseHostChain() {
    return {
        chainId: "",
        connectionId: "",
        params: exports.HostChainLSParams.fromPartial({}),
        hostDenom: "",
        channelId: "",
        portId: "",
        delegationAccount: exports.ICAAccount.fromPartial({}),
        rewardsAccount: exports.ICAAccount.fromPartial({}),
        validators: [],
        minimumDeposit: "",
        cValue: "",
        lastCValue: "",
        unbondingFactor: BigInt(0),
        active: false,
        autoCompoundFactor: "",
        flags: exports.HostChainFlags.fromPartial({}),
        rewardParams: exports.RewardParams.fromPartial({}),
    };
}
exports.HostChain = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.connectionId !== "") {
            writer.uint32(18).string(message.connectionId);
        }
        if (message.params !== undefined) {
            exports.HostChainLSParams.encode(message.params, writer.uint32(26).fork()).ldelim();
        }
        if (message.hostDenom !== "") {
            writer.uint32(34).string(message.hostDenom);
        }
        if (message.channelId !== "") {
            writer.uint32(42).string(message.channelId);
        }
        if (message.portId !== "") {
            writer.uint32(50).string(message.portId);
        }
        if (message.delegationAccount !== undefined) {
            exports.ICAAccount.encode(message.delegationAccount, writer.uint32(58).fork()).ldelim();
        }
        if (message.rewardsAccount !== undefined) {
            exports.ICAAccount.encode(message.rewardsAccount, writer.uint32(66).fork()).ldelim();
        }
        for (const v of message.validators) {
            exports.Validator.encode(v, writer.uint32(74).fork()).ldelim();
        }
        if (message.minimumDeposit !== "") {
            writer.uint32(82).string(message.minimumDeposit);
        }
        if (message.cValue !== "") {
            writer.uint32(90).string(message.cValue);
        }
        if (message.lastCValue !== "") {
            writer.uint32(98).string(message.lastCValue);
        }
        if (message.unbondingFactor !== BigInt(0)) {
            writer.uint32(104).int64(message.unbondingFactor);
        }
        if (message.active === true) {
            writer.uint32(112).bool(message.active);
        }
        if (message.autoCompoundFactor !== "") {
            writer.uint32(122).string(message.autoCompoundFactor);
        }
        if (message.flags !== undefined) {
            exports.HostChainFlags.encode(message.flags, writer.uint32(130).fork()).ldelim();
        }
        if (message.rewardParams !== undefined) {
            exports.RewardParams.encode(message.rewardParams, writer.uint32(138).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostChain();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.connectionId = reader.string();
                    break;
                case 3:
                    message.params = exports.HostChainLSParams.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.hostDenom = reader.string();
                    break;
                case 5:
                    message.channelId = reader.string();
                    break;
                case 6:
                    message.portId = reader.string();
                    break;
                case 7:
                    message.delegationAccount = exports.ICAAccount.decode(reader, reader.uint32());
                    break;
                case 8:
                    message.rewardsAccount = exports.ICAAccount.decode(reader, reader.uint32());
                    break;
                case 9:
                    message.validators.push(exports.Validator.decode(reader, reader.uint32()));
                    break;
                case 10:
                    message.minimumDeposit = reader.string();
                    break;
                case 11:
                    message.cValue = reader.string();
                    break;
                case 12:
                    message.lastCValue = reader.string();
                    break;
                case 13:
                    message.unbondingFactor = reader.int64();
                    break;
                case 14:
                    message.active = reader.bool();
                    break;
                case 15:
                    message.autoCompoundFactor = reader.string();
                    break;
                case 16:
                    message.flags = exports.HostChainFlags.decode(reader, reader.uint32());
                    break;
                case 17:
                    message.rewardParams = exports.RewardParams.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostChain();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.connectionId))
            obj.connectionId = String(object.connectionId);
        if ((0, helpers_1.isSet)(object.params))
            obj.params = exports.HostChainLSParams.fromJSON(object.params);
        if ((0, helpers_1.isSet)(object.hostDenom))
            obj.hostDenom = String(object.hostDenom);
        if ((0, helpers_1.isSet)(object.channelId))
            obj.channelId = String(object.channelId);
        if ((0, helpers_1.isSet)(object.portId))
            obj.portId = String(object.portId);
        if ((0, helpers_1.isSet)(object.delegationAccount))
            obj.delegationAccount = exports.ICAAccount.fromJSON(object.delegationAccount);
        if ((0, helpers_1.isSet)(object.rewardsAccount))
            obj.rewardsAccount = exports.ICAAccount.fromJSON(object.rewardsAccount);
        if (Array.isArray(object?.validators))
            obj.validators = object.validators.map((e) => exports.Validator.fromJSON(e));
        if ((0, helpers_1.isSet)(object.minimumDeposit))
            obj.minimumDeposit = String(object.minimumDeposit);
        if ((0, helpers_1.isSet)(object.cValue))
            obj.cValue = String(object.cValue);
        if ((0, helpers_1.isSet)(object.lastCValue))
            obj.lastCValue = String(object.lastCValue);
        if ((0, helpers_1.isSet)(object.unbondingFactor))
            obj.unbondingFactor = BigInt(object.unbondingFactor.toString());
        if ((0, helpers_1.isSet)(object.active))
            obj.active = Boolean(object.active);
        if ((0, helpers_1.isSet)(object.autoCompoundFactor))
            obj.autoCompoundFactor = String(object.autoCompoundFactor);
        if ((0, helpers_1.isSet)(object.flags))
            obj.flags = exports.HostChainFlags.fromJSON(object.flags);
        if ((0, helpers_1.isSet)(object.rewardParams))
            obj.rewardParams = exports.RewardParams.fromJSON(object.rewardParams);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.connectionId !== undefined && (obj.connectionId = message.connectionId);
        message.params !== undefined &&
            (obj.params = message.params ? exports.HostChainLSParams.toJSON(message.params) : undefined);
        message.hostDenom !== undefined && (obj.hostDenom = message.hostDenom);
        message.channelId !== undefined && (obj.channelId = message.channelId);
        message.portId !== undefined && (obj.portId = message.portId);
        message.delegationAccount !== undefined &&
            (obj.delegationAccount = message.delegationAccount
                ? exports.ICAAccount.toJSON(message.delegationAccount)
                : undefined);
        message.rewardsAccount !== undefined &&
            (obj.rewardsAccount = message.rewardsAccount ? exports.ICAAccount.toJSON(message.rewardsAccount) : undefined);
        if (message.validators) {
            obj.validators = message.validators.map((e) => (e ? exports.Validator.toJSON(e) : undefined));
        }
        else {
            obj.validators = [];
        }
        message.minimumDeposit !== undefined && (obj.minimumDeposit = message.minimumDeposit);
        message.cValue !== undefined && (obj.cValue = message.cValue);
        message.lastCValue !== undefined && (obj.lastCValue = message.lastCValue);
        message.unbondingFactor !== undefined &&
            (obj.unbondingFactor = (message.unbondingFactor || BigInt(0)).toString());
        message.active !== undefined && (obj.active = message.active);
        message.autoCompoundFactor !== undefined && (obj.autoCompoundFactor = message.autoCompoundFactor);
        message.flags !== undefined &&
            (obj.flags = message.flags ? exports.HostChainFlags.toJSON(message.flags) : undefined);
        message.rewardParams !== undefined &&
            (obj.rewardParams = message.rewardParams ? exports.RewardParams.toJSON(message.rewardParams) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostChain();
        message.chainId = object.chainId ?? "";
        message.connectionId = object.connectionId ?? "";
        if (object.params !== undefined && object.params !== null) {
            message.params = exports.HostChainLSParams.fromPartial(object.params);
        }
        message.hostDenom = object.hostDenom ?? "";
        message.channelId = object.channelId ?? "";
        message.portId = object.portId ?? "";
        if (object.delegationAccount !== undefined && object.delegationAccount !== null) {
            message.delegationAccount = exports.ICAAccount.fromPartial(object.delegationAccount);
        }
        if (object.rewardsAccount !== undefined && object.rewardsAccount !== null) {
            message.rewardsAccount = exports.ICAAccount.fromPartial(object.rewardsAccount);
        }
        message.validators = object.validators?.map((e) => exports.Validator.fromPartial(e)) || [];
        message.minimumDeposit = object.minimumDeposit ?? "";
        message.cValue = object.cValue ?? "";
        message.lastCValue = object.lastCValue ?? "";
        if (object.unbondingFactor !== undefined && object.unbondingFactor !== null) {
            message.unbondingFactor = BigInt(object.unbondingFactor.toString());
        }
        message.active = object.active ?? false;
        message.autoCompoundFactor = object.autoCompoundFactor ?? "";
        if (object.flags !== undefined && object.flags !== null) {
            message.flags = exports.HostChainFlags.fromPartial(object.flags);
        }
        if (object.rewardParams !== undefined && object.rewardParams !== null) {
            message.rewardParams = exports.RewardParams.fromPartial(object.rewardParams);
        }
        return message;
    },
};
function createBaseHostChainFlags() {
    return {
        lsm: false,
    };
}
exports.HostChainFlags = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.lsm === true) {
            writer.uint32(8).bool(message.lsm);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostChainFlags();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.lsm = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostChainFlags();
        if ((0, helpers_1.isSet)(object.lsm))
            obj.lsm = Boolean(object.lsm);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.lsm !== undefined && (obj.lsm = message.lsm);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostChainFlags();
        message.lsm = object.lsm ?? false;
        return message;
    },
};
function createBaseRewardParams() {
    return {
        denom: "",
        destination: "",
    };
}
exports.RewardParams = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.denom !== "") {
            writer.uint32(10).string(message.denom);
        }
        if (message.destination !== "") {
            writer.uint32(18).string(message.destination);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRewardParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.denom = reader.string();
                    break;
                case 2:
                    message.destination = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseRewardParams();
        if ((0, helpers_1.isSet)(object.denom))
            obj.denom = String(object.denom);
        if ((0, helpers_1.isSet)(object.destination))
            obj.destination = String(object.destination);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.denom !== undefined && (obj.denom = message.denom);
        message.destination !== undefined && (obj.destination = message.destination);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRewardParams();
        message.denom = object.denom ?? "";
        message.destination = object.destination ?? "";
        return message;
    },
};
function createBaseHostChainLSParams() {
    return {
        depositFee: "",
        restakeFee: "",
        unstakeFee: "",
        redemptionFee: "",
        lsmValidatorCap: "",
        lsmBondFactor: "",
        maxEntries: 0,
        redelegationAcceptableDelta: "",
        upperCValueLimit: "",
        lowerCValueLimit: "",
    };
}
exports.HostChainLSParams = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.depositFee !== "") {
            writer.uint32(10).string(message.depositFee);
        }
        if (message.restakeFee !== "") {
            writer.uint32(18).string(message.restakeFee);
        }
        if (message.unstakeFee !== "") {
            writer.uint32(26).string(message.unstakeFee);
        }
        if (message.redemptionFee !== "") {
            writer.uint32(34).string(message.redemptionFee);
        }
        if (message.lsmValidatorCap !== "") {
            writer.uint32(50).string(message.lsmValidatorCap);
        }
        if (message.lsmBondFactor !== "") {
            writer.uint32(58).string(message.lsmBondFactor);
        }
        if (message.maxEntries !== 0) {
            writer.uint32(64).uint32(message.maxEntries);
        }
        if (message.redelegationAcceptableDelta !== "") {
            writer.uint32(74).string(message.redelegationAcceptableDelta);
        }
        if (message.upperCValueLimit !== "") {
            writer.uint32(82).string(message.upperCValueLimit);
        }
        if (message.lowerCValueLimit !== "") {
            writer.uint32(90).string(message.lowerCValueLimit);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseHostChainLSParams();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.depositFee = reader.string();
                    break;
                case 2:
                    message.restakeFee = reader.string();
                    break;
                case 3:
                    message.unstakeFee = reader.string();
                    break;
                case 4:
                    message.redemptionFee = reader.string();
                    break;
                case 6:
                    message.lsmValidatorCap = reader.string();
                    break;
                case 7:
                    message.lsmBondFactor = reader.string();
                    break;
                case 8:
                    message.maxEntries = reader.uint32();
                    break;
                case 9:
                    message.redelegationAcceptableDelta = reader.string();
                    break;
                case 10:
                    message.upperCValueLimit = reader.string();
                    break;
                case 11:
                    message.lowerCValueLimit = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseHostChainLSParams();
        if ((0, helpers_1.isSet)(object.depositFee))
            obj.depositFee = String(object.depositFee);
        if ((0, helpers_1.isSet)(object.restakeFee))
            obj.restakeFee = String(object.restakeFee);
        if ((0, helpers_1.isSet)(object.unstakeFee))
            obj.unstakeFee = String(object.unstakeFee);
        if ((0, helpers_1.isSet)(object.redemptionFee))
            obj.redemptionFee = String(object.redemptionFee);
        if ((0, helpers_1.isSet)(object.lsmValidatorCap))
            obj.lsmValidatorCap = String(object.lsmValidatorCap);
        if ((0, helpers_1.isSet)(object.lsmBondFactor))
            obj.lsmBondFactor = String(object.lsmBondFactor);
        if ((0, helpers_1.isSet)(object.maxEntries))
            obj.maxEntries = Number(object.maxEntries);
        if ((0, helpers_1.isSet)(object.redelegationAcceptableDelta))
            obj.redelegationAcceptableDelta = String(object.redelegationAcceptableDelta);
        if ((0, helpers_1.isSet)(object.upperCValueLimit))
            obj.upperCValueLimit = String(object.upperCValueLimit);
        if ((0, helpers_1.isSet)(object.lowerCValueLimit))
            obj.lowerCValueLimit = String(object.lowerCValueLimit);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.depositFee !== undefined && (obj.depositFee = message.depositFee);
        message.restakeFee !== undefined && (obj.restakeFee = message.restakeFee);
        message.unstakeFee !== undefined && (obj.unstakeFee = message.unstakeFee);
        message.redemptionFee !== undefined && (obj.redemptionFee = message.redemptionFee);
        message.lsmValidatorCap !== undefined && (obj.lsmValidatorCap = message.lsmValidatorCap);
        message.lsmBondFactor !== undefined && (obj.lsmBondFactor = message.lsmBondFactor);
        message.maxEntries !== undefined && (obj.maxEntries = Math.round(message.maxEntries));
        message.redelegationAcceptableDelta !== undefined &&
            (obj.redelegationAcceptableDelta = message.redelegationAcceptableDelta);
        message.upperCValueLimit !== undefined && (obj.upperCValueLimit = message.upperCValueLimit);
        message.lowerCValueLimit !== undefined && (obj.lowerCValueLimit = message.lowerCValueLimit);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseHostChainLSParams();
        message.depositFee = object.depositFee ?? "";
        message.restakeFee = object.restakeFee ?? "";
        message.unstakeFee = object.unstakeFee ?? "";
        message.redemptionFee = object.redemptionFee ?? "";
        message.lsmValidatorCap = object.lsmValidatorCap ?? "";
        message.lsmBondFactor = object.lsmBondFactor ?? "";
        message.maxEntries = object.maxEntries ?? 0;
        message.redelegationAcceptableDelta = object.redelegationAcceptableDelta ?? "";
        message.upperCValueLimit = object.upperCValueLimit ?? "";
        message.lowerCValueLimit = object.lowerCValueLimit ?? "";
        return message;
    },
};
function createBaseICAAccount() {
    return {
        address: "",
        balance: coin_1.Coin.fromPartial({}),
        owner: "",
        channelState: 0,
    };
}
exports.ICAAccount = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.address !== "") {
            writer.uint32(10).string(message.address);
        }
        if (message.balance !== undefined) {
            coin_1.Coin.encode(message.balance, writer.uint32(18).fork()).ldelim();
        }
        if (message.owner !== "") {
            writer.uint32(26).string(message.owner);
        }
        if (message.channelState !== 0) {
            writer.uint32(32).int32(message.channelState);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseICAAccount();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.address = reader.string();
                    break;
                case 2:
                    message.balance = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.owner = reader.string();
                    break;
                case 4:
                    message.channelState = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseICAAccount();
        if ((0, helpers_1.isSet)(object.address))
            obj.address = String(object.address);
        if ((0, helpers_1.isSet)(object.balance))
            obj.balance = coin_1.Coin.fromJSON(object.balance);
        if ((0, helpers_1.isSet)(object.owner))
            obj.owner = String(object.owner);
        if ((0, helpers_1.isSet)(object.channelState))
            obj.channelState = iCAAccount_ChannelStateFromJSON(object.channelState);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.address !== undefined && (obj.address = message.address);
        message.balance !== undefined &&
            (obj.balance = message.balance ? coin_1.Coin.toJSON(message.balance) : undefined);
        message.owner !== undefined && (obj.owner = message.owner);
        message.channelState !== undefined &&
            (obj.channelState = iCAAccount_ChannelStateToJSON(message.channelState));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseICAAccount();
        message.address = object.address ?? "";
        if (object.balance !== undefined && object.balance !== null) {
            message.balance = coin_1.Coin.fromPartial(object.balance);
        }
        message.owner = object.owner ?? "";
        message.channelState = object.channelState ?? 0;
        return message;
    },
};
function createBaseValidator() {
    return {
        operatorAddress: "",
        status: "",
        weight: "",
        delegatedAmount: "",
        exchangeRate: "",
        unbondingEpoch: BigInt(0),
        delegable: false,
    };
}
exports.Validator = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.operatorAddress !== "") {
            writer.uint32(10).string(message.operatorAddress);
        }
        if (message.status !== "") {
            writer.uint32(18).string(message.status);
        }
        if (message.weight !== "") {
            writer.uint32(26).string(message.weight);
        }
        if (message.delegatedAmount !== "") {
            writer.uint32(34).string(message.delegatedAmount);
        }
        if (message.exchangeRate !== "") {
            writer.uint32(42).string(message.exchangeRate);
        }
        if (message.unbondingEpoch !== BigInt(0)) {
            writer.uint32(48).int64(message.unbondingEpoch);
        }
        if (message.delegable === true) {
            writer.uint32(56).bool(message.delegable);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidator();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.operatorAddress = reader.string();
                    break;
                case 2:
                    message.status = reader.string();
                    break;
                case 3:
                    message.weight = reader.string();
                    break;
                case 4:
                    message.delegatedAmount = reader.string();
                    break;
                case 5:
                    message.exchangeRate = reader.string();
                    break;
                case 6:
                    message.unbondingEpoch = reader.int64();
                    break;
                case 7:
                    message.delegable = reader.bool();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseValidator();
        if ((0, helpers_1.isSet)(object.operatorAddress))
            obj.operatorAddress = String(object.operatorAddress);
        if ((0, helpers_1.isSet)(object.status))
            obj.status = String(object.status);
        if ((0, helpers_1.isSet)(object.weight))
            obj.weight = String(object.weight);
        if ((0, helpers_1.isSet)(object.delegatedAmount))
            obj.delegatedAmount = String(object.delegatedAmount);
        if ((0, helpers_1.isSet)(object.exchangeRate))
            obj.exchangeRate = String(object.exchangeRate);
        if ((0, helpers_1.isSet)(object.unbondingEpoch))
            obj.unbondingEpoch = BigInt(object.unbondingEpoch.toString());
        if ((0, helpers_1.isSet)(object.delegable))
            obj.delegable = Boolean(object.delegable);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.operatorAddress !== undefined && (obj.operatorAddress = message.operatorAddress);
        message.status !== undefined && (obj.status = message.status);
        message.weight !== undefined && (obj.weight = message.weight);
        message.delegatedAmount !== undefined && (obj.delegatedAmount = message.delegatedAmount);
        message.exchangeRate !== undefined && (obj.exchangeRate = message.exchangeRate);
        message.unbondingEpoch !== undefined &&
            (obj.unbondingEpoch = (message.unbondingEpoch || BigInt(0)).toString());
        message.delegable !== undefined && (obj.delegable = message.delegable);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidator();
        message.operatorAddress = object.operatorAddress ?? "";
        message.status = object.status ?? "";
        message.weight = object.weight ?? "";
        message.delegatedAmount = object.delegatedAmount ?? "";
        message.exchangeRate = object.exchangeRate ?? "";
        if (object.unbondingEpoch !== undefined && object.unbondingEpoch !== null) {
            message.unbondingEpoch = BigInt(object.unbondingEpoch.toString());
        }
        message.delegable = object.delegable ?? false;
        return message;
    },
};
function createBaseDeposit() {
    return {
        chainId: "",
        amount: coin_1.Coin.fromPartial({}),
        epoch: BigInt(0),
        state: 0,
        ibcSequenceId: "",
    };
}
exports.Deposit = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(18).fork()).ldelim();
        }
        if (message.epoch !== BigInt(0)) {
            writer.uint32(24).int64(message.epoch);
        }
        if (message.state !== 0) {
            writer.uint32(32).int32(message.state);
        }
        if (message.ibcSequenceId !== "") {
            writer.uint32(42).string(message.ibcSequenceId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 3:
                    message.epoch = reader.int64();
                    break;
                case 4:
                    message.state = reader.int32();
                    break;
                case 5:
                    message.ibcSequenceId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseDeposit();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = coin_1.Coin.fromJSON(object.amount);
        if ((0, helpers_1.isSet)(object.epoch))
            obj.epoch = BigInt(object.epoch.toString());
        if ((0, helpers_1.isSet)(object.state))
            obj.state = deposit_DepositStateFromJSON(object.state);
        if ((0, helpers_1.isSet)(object.ibcSequenceId))
            obj.ibcSequenceId = String(object.ibcSequenceId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        message.epoch !== undefined && (obj.epoch = (message.epoch || BigInt(0)).toString());
        message.state !== undefined && (obj.state = deposit_DepositStateToJSON(message.state));
        message.ibcSequenceId !== undefined && (obj.ibcSequenceId = message.ibcSequenceId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseDeposit();
        message.chainId = object.chainId ?? "";
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin_1.Coin.fromPartial(object.amount);
        }
        if (object.epoch !== undefined && object.epoch !== null) {
            message.epoch = BigInt(object.epoch.toString());
        }
        message.state = object.state ?? 0;
        message.ibcSequenceId = object.ibcSequenceId ?? "";
        return message;
    },
};
function createBaseLSMDeposit() {
    return {
        chainId: "",
        amount: "",
        shares: "",
        denom: "",
        ibcDenom: "",
        delegatorAddress: "",
        state: 0,
        ibcSequenceId: "",
    };
}
exports.LSMDeposit = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.amount !== "") {
            writer.uint32(18).string(message.amount);
        }
        if (message.shares !== "") {
            writer.uint32(26).string(message.shares);
        }
        if (message.denom !== "") {
            writer.uint32(34).string(message.denom);
        }
        if (message.ibcDenom !== "") {
            writer.uint32(42).string(message.ibcDenom);
        }
        if (message.delegatorAddress !== "") {
            writer.uint32(50).string(message.delegatorAddress);
        }
        if (message.state !== 0) {
            writer.uint32(56).int32(message.state);
        }
        if (message.ibcSequenceId !== "") {
            writer.uint32(66).string(message.ibcSequenceId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseLSMDeposit();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.amount = reader.string();
                    break;
                case 3:
                    message.shares = reader.string();
                    break;
                case 4:
                    message.denom = reader.string();
                    break;
                case 5:
                    message.ibcDenom = reader.string();
                    break;
                case 6:
                    message.delegatorAddress = reader.string();
                    break;
                case 7:
                    message.state = reader.int32();
                    break;
                case 8:
                    message.ibcSequenceId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseLSMDeposit();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = String(object.amount);
        if ((0, helpers_1.isSet)(object.shares))
            obj.shares = String(object.shares);
        if ((0, helpers_1.isSet)(object.denom))
            obj.denom = String(object.denom);
        if ((0, helpers_1.isSet)(object.ibcDenom))
            obj.ibcDenom = String(object.ibcDenom);
        if ((0, helpers_1.isSet)(object.delegatorAddress))
            obj.delegatorAddress = String(object.delegatorAddress);
        if ((0, helpers_1.isSet)(object.state))
            obj.state = lSMDeposit_LSMDepositStateFromJSON(object.state);
        if ((0, helpers_1.isSet)(object.ibcSequenceId))
            obj.ibcSequenceId = String(object.ibcSequenceId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.amount !== undefined && (obj.amount = message.amount);
        message.shares !== undefined && (obj.shares = message.shares);
        message.denom !== undefined && (obj.denom = message.denom);
        message.ibcDenom !== undefined && (obj.ibcDenom = message.ibcDenom);
        message.delegatorAddress !== undefined && (obj.delegatorAddress = message.delegatorAddress);
        message.state !== undefined && (obj.state = lSMDeposit_LSMDepositStateToJSON(message.state));
        message.ibcSequenceId !== undefined && (obj.ibcSequenceId = message.ibcSequenceId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseLSMDeposit();
        message.chainId = object.chainId ?? "";
        message.amount = object.amount ?? "";
        message.shares = object.shares ?? "";
        message.denom = object.denom ?? "";
        message.ibcDenom = object.ibcDenom ?? "";
        message.delegatorAddress = object.delegatorAddress ?? "";
        message.state = object.state ?? 0;
        message.ibcSequenceId = object.ibcSequenceId ?? "";
        return message;
    },
};
function createBaseUnbonding() {
    return {
        chainId: "",
        epochNumber: BigInt(0),
        matureTime: timestamp_1.Timestamp.fromPartial({}),
        burnAmount: coin_1.Coin.fromPartial({}),
        unbondAmount: coin_1.Coin.fromPartial({}),
        ibcSequenceId: "",
        state: 0,
    };
}
exports.Unbonding = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(16).int64(message.epochNumber);
        }
        if (message.matureTime !== undefined) {
            timestamp_1.Timestamp.encode(message.matureTime, writer.uint32(26).fork()).ldelim();
        }
        if (message.burnAmount !== undefined) {
            coin_1.Coin.encode(message.burnAmount, writer.uint32(34).fork()).ldelim();
        }
        if (message.unbondAmount !== undefined) {
            coin_1.Coin.encode(message.unbondAmount, writer.uint32(42).fork()).ldelim();
        }
        if (message.ibcSequenceId !== "") {
            writer.uint32(50).string(message.ibcSequenceId);
        }
        if (message.state !== 0) {
            writer.uint32(56).int32(message.state);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUnbonding();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.epochNumber = reader.int64();
                    break;
                case 3:
                    message.matureTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.burnAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.unbondAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcSequenceId = reader.string();
                    break;
                case 7:
                    message.state = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseUnbonding();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        if ((0, helpers_1.isSet)(object.matureTime))
            obj.matureTime = (0, helpers_1.fromJsonTimestamp)(object.matureTime);
        if ((0, helpers_1.isSet)(object.burnAmount))
            obj.burnAmount = coin_1.Coin.fromJSON(object.burnAmount);
        if ((0, helpers_1.isSet)(object.unbondAmount))
            obj.unbondAmount = coin_1.Coin.fromJSON(object.unbondAmount);
        if ((0, helpers_1.isSet)(object.ibcSequenceId))
            obj.ibcSequenceId = String(object.ibcSequenceId);
        if ((0, helpers_1.isSet)(object.state))
            obj.state = unbonding_UnbondingStateFromJSON(object.state);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        message.matureTime !== undefined && (obj.matureTime = (0, helpers_1.fromTimestamp)(message.matureTime).toISOString());
        message.burnAmount !== undefined &&
            (obj.burnAmount = message.burnAmount ? coin_1.Coin.toJSON(message.burnAmount) : undefined);
        message.unbondAmount !== undefined &&
            (obj.unbondAmount = message.unbondAmount ? coin_1.Coin.toJSON(message.unbondAmount) : undefined);
        message.ibcSequenceId !== undefined && (obj.ibcSequenceId = message.ibcSequenceId);
        message.state !== undefined && (obj.state = unbonding_UnbondingStateToJSON(message.state));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUnbonding();
        message.chainId = object.chainId ?? "";
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        if (object.matureTime !== undefined && object.matureTime !== null) {
            message.matureTime = timestamp_1.Timestamp.fromPartial(object.matureTime);
        }
        if (object.burnAmount !== undefined && object.burnAmount !== null) {
            message.burnAmount = coin_1.Coin.fromPartial(object.burnAmount);
        }
        if (object.unbondAmount !== undefined && object.unbondAmount !== null) {
            message.unbondAmount = coin_1.Coin.fromPartial(object.unbondAmount);
        }
        message.ibcSequenceId = object.ibcSequenceId ?? "";
        message.state = object.state ?? 0;
        return message;
    },
};
function createBaseUserUnbonding() {
    return {
        chainId: "",
        epochNumber: BigInt(0),
        address: "",
        stkAmount: coin_1.Coin.fromPartial({}),
        unbondAmount: coin_1.Coin.fromPartial({}),
    };
}
exports.UserUnbonding = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(16).int64(message.epochNumber);
        }
        if (message.address !== "") {
            writer.uint32(26).string(message.address);
        }
        if (message.stkAmount !== undefined) {
            coin_1.Coin.encode(message.stkAmount, writer.uint32(34).fork()).ldelim();
        }
        if (message.unbondAmount !== undefined) {
            coin_1.Coin.encode(message.unbondAmount, writer.uint32(42).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseUserUnbonding();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.epochNumber = reader.int64();
                    break;
                case 3:
                    message.address = reader.string();
                    break;
                case 4:
                    message.stkAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 5:
                    message.unbondAmount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseUserUnbonding();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        if ((0, helpers_1.isSet)(object.address))
            obj.address = String(object.address);
        if ((0, helpers_1.isSet)(object.stkAmount))
            obj.stkAmount = coin_1.Coin.fromJSON(object.stkAmount);
        if ((0, helpers_1.isSet)(object.unbondAmount))
            obj.unbondAmount = coin_1.Coin.fromJSON(object.unbondAmount);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        message.address !== undefined && (obj.address = message.address);
        message.stkAmount !== undefined &&
            (obj.stkAmount = message.stkAmount ? coin_1.Coin.toJSON(message.stkAmount) : undefined);
        message.unbondAmount !== undefined &&
            (obj.unbondAmount = message.unbondAmount ? coin_1.Coin.toJSON(message.unbondAmount) : undefined);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseUserUnbonding();
        message.chainId = object.chainId ?? "";
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        message.address = object.address ?? "";
        if (object.stkAmount !== undefined && object.stkAmount !== null) {
            message.stkAmount = coin_1.Coin.fromPartial(object.stkAmount);
        }
        if (object.unbondAmount !== undefined && object.unbondAmount !== null) {
            message.unbondAmount = coin_1.Coin.fromPartial(object.unbondAmount);
        }
        return message;
    },
};
function createBaseValidatorUnbonding() {
    return {
        chainId: "",
        epochNumber: BigInt(0),
        matureTime: timestamp_1.Timestamp.fromPartial({}),
        validatorAddress: "",
        amount: coin_1.Coin.fromPartial({}),
        ibcSequenceId: "",
    };
}
exports.ValidatorUnbonding = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.epochNumber !== BigInt(0)) {
            writer.uint32(16).int64(message.epochNumber);
        }
        if (message.matureTime !== undefined) {
            timestamp_1.Timestamp.encode(message.matureTime, writer.uint32(26).fork()).ldelim();
        }
        if (message.validatorAddress !== "") {
            writer.uint32(34).string(message.validatorAddress);
        }
        if (message.amount !== undefined) {
            coin_1.Coin.encode(message.amount, writer.uint32(42).fork()).ldelim();
        }
        if (message.ibcSequenceId !== "") {
            writer.uint32(50).string(message.ibcSequenceId);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseValidatorUnbonding();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.epochNumber = reader.int64();
                    break;
                case 3:
                    message.matureTime = timestamp_1.Timestamp.decode(reader, reader.uint32());
                    break;
                case 4:
                    message.validatorAddress = reader.string();
                    break;
                case 5:
                    message.amount = coin_1.Coin.decode(reader, reader.uint32());
                    break;
                case 6:
                    message.ibcSequenceId = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseValidatorUnbonding();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.epochNumber))
            obj.epochNumber = BigInt(object.epochNumber.toString());
        if ((0, helpers_1.isSet)(object.matureTime))
            obj.matureTime = (0, helpers_1.fromJsonTimestamp)(object.matureTime);
        if ((0, helpers_1.isSet)(object.validatorAddress))
            obj.validatorAddress = String(object.validatorAddress);
        if ((0, helpers_1.isSet)(object.amount))
            obj.amount = coin_1.Coin.fromJSON(object.amount);
        if ((0, helpers_1.isSet)(object.ibcSequenceId))
            obj.ibcSequenceId = String(object.ibcSequenceId);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.epochNumber !== undefined && (obj.epochNumber = (message.epochNumber || BigInt(0)).toString());
        message.matureTime !== undefined && (obj.matureTime = (0, helpers_1.fromTimestamp)(message.matureTime).toISOString());
        message.validatorAddress !== undefined && (obj.validatorAddress = message.validatorAddress);
        message.amount !== undefined && (obj.amount = message.amount ? coin_1.Coin.toJSON(message.amount) : undefined);
        message.ibcSequenceId !== undefined && (obj.ibcSequenceId = message.ibcSequenceId);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseValidatorUnbonding();
        message.chainId = object.chainId ?? "";
        if (object.epochNumber !== undefined && object.epochNumber !== null) {
            message.epochNumber = BigInt(object.epochNumber.toString());
        }
        if (object.matureTime !== undefined && object.matureTime !== null) {
            message.matureTime = timestamp_1.Timestamp.fromPartial(object.matureTime);
        }
        message.validatorAddress = object.validatorAddress ?? "";
        if (object.amount !== undefined && object.amount !== null) {
            message.amount = coin_1.Coin.fromPartial(object.amount);
        }
        message.ibcSequenceId = object.ibcSequenceId ?? "";
        return message;
    },
};
function createBaseKVUpdate() {
    return {
        key: "",
        value: "",
    };
}
exports.KVUpdate = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseKVUpdate();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.key = reader.string();
                    break;
                case 2:
                    message.value = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseKVUpdate();
        if ((0, helpers_1.isSet)(object.key))
            obj.key = String(object.key);
        if ((0, helpers_1.isSet)(object.value))
            obj.value = String(object.value);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.key !== undefined && (obj.key = message.key);
        message.value !== undefined && (obj.value = message.value);
        return obj;
    },
    fromPartial(object) {
        const message = createBaseKVUpdate();
        message.key = object.key ?? "";
        message.value = object.value ?? "";
        return message;
    },
};
function createBaseRedelegations() {
    return {
        chainID: "",
        redelegations: [],
    };
}
exports.Redelegations = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainID !== "") {
            writer.uint32(10).string(message.chainID);
        }
        for (const v of message.redelegations) {
            staking_1.Redelegation.encode(v, writer.uint32(18).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegations();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainID = reader.string();
                    break;
                case 2:
                    message.redelegations.push(staking_1.Redelegation.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseRedelegations();
        if ((0, helpers_1.isSet)(object.chainID))
            obj.chainID = String(object.chainID);
        if (Array.isArray(object?.redelegations))
            obj.redelegations = object.redelegations.map((e) => staking_1.Redelegation.fromJSON(e));
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainID !== undefined && (obj.chainID = message.chainID);
        if (message.redelegations) {
            obj.redelegations = message.redelegations.map((e) => (e ? staking_1.Redelegation.toJSON(e) : undefined));
        }
        else {
            obj.redelegations = [];
        }
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRedelegations();
        message.chainID = object.chainID ?? "";
        message.redelegations = object.redelegations?.map((e) => staking_1.Redelegation.fromPartial(e)) || [];
        return message;
    },
};
function createBaseRedelegateTx() {
    return {
        chainId: "",
        ibcSequenceId: "",
        state: 0,
    };
}
exports.RedelegateTx = {
    encode(message, writer = binary_1.BinaryWriter.create()) {
        if (message.chainId !== "") {
            writer.uint32(10).string(message.chainId);
        }
        if (message.ibcSequenceId !== "") {
            writer.uint32(18).string(message.ibcSequenceId);
        }
        if (message.state !== 0) {
            writer.uint32(24).int32(message.state);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof binary_1.BinaryReader ? input : new binary_1.BinaryReader(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseRedelegateTx();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.chainId = reader.string();
                    break;
                case 2:
                    message.ibcSequenceId = reader.string();
                    break;
                case 3:
                    message.state = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const obj = createBaseRedelegateTx();
        if ((0, helpers_1.isSet)(object.chainId))
            obj.chainId = String(object.chainId);
        if ((0, helpers_1.isSet)(object.ibcSequenceId))
            obj.ibcSequenceId = String(object.ibcSequenceId);
        if ((0, helpers_1.isSet)(object.state))
            obj.state = redelegateTx_RedelegateTxStateFromJSON(object.state);
        return obj;
    },
    toJSON(message) {
        const obj = {};
        message.chainId !== undefined && (obj.chainId = message.chainId);
        message.ibcSequenceId !== undefined && (obj.ibcSequenceId = message.ibcSequenceId);
        message.state !== undefined && (obj.state = redelegateTx_RedelegateTxStateToJSON(message.state));
        return obj;
    },
    fromPartial(object) {
        const message = createBaseRedelegateTx();
        message.chainId = object.chainId ?? "";
        message.ibcSequenceId = object.ibcSequenceId ?? "";
        message.state = object.state ?? 0;
        return message;
    },
};
//# sourceMappingURL=liquidstakeibc.js.map